var map = {
	"./auth.vue": "UmH6",
	"./default.vue": "Pyxr",
	"./docs.vue": "jBGl",
	"./main.vue": "+qbq",
	"./navless.vue": "vGgY",
	"./other.vue": "XNcP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gR1n";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layouts nonrecursive ^(?!.*(?:ignore)).*\.vue$
// module id = gR1n
// module chunks = 13 14